import React from 'react';
import { stripScripts } from 'ub/utils';

export default class InputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: props.value};
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onUserInput = this.onUserInput.bind(this);
    this.onChangeValueHandler = this.onChangeValueHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({value: nextProps.value});
  }

  onKeyDown(ev) {
    const RETURN_KEY = 13;

    if (ev.keyCode === RETURN_KEY) {
      ev.preventDefault();
      this.onChangeValueHandler(ev);
    }

    return true;
  }

  onUserInput(ev) {
    this.setState({value: ev.target.value.trim()});
  }

  onChangeValueHandler(ev0) {
    const ev = ev0;
    ev.target.value = stripScripts(ev0.target.value);
    this.props.valueChangeHandler(ev);
  }

  render() {
    const disableField = Boolean(this.props.readonly);
    const divClassName = 'input-field' +
      (this.props.containerClassName ? ' ' + this.props.containerClassName : '');
    const labelClassName = 'form-elm-mini-label' +
      (this.props.labelClassName ? ' ' + this.props.labelClassName : '');
    const inputClassName = 'form-elm-input-text' +
      (this.props.inputClassName ? ' ' + this.props.inputClassName : '');

    const fieldLabel = this.props.hideLabel
      ? null
      : <label className={labelClassName}>{this.props.label}</label>;

    return (
      <div className={divClassName}>
        {fieldLabel}
        <input
          className={inputClassName}
          onChange={this.onUserInput}
          onBlur={this.onChangeValueHandler}
          onKeyDown={this.onKeyDown}
          onKeyUp={this.props.onKeyUp}
          disabled={disableField}
          value={this.state.value}
          onFocus={(ev) => window.editor.keyController.requestFocus(ev.target)}
          maxLength={this.props.maxLength || ''}
        />
      </div>
    );
  }
}

InputField.propTypes = {
  value: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.number
  ]),
  readonly: React.PropTypes.bool,
  hideLabel: React.PropTypes.bool,
  containerClassName: React.PropTypes.string,
  label: React.PropTypes.string,
  labelClassName: React.PropTypes.string,
  inputClassName: React.PropTypes.string,
  valueChangeHandler: React.PropTypes.func,
  maxLength: React.PropTypes.number,
  onKeyUp: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/input-field.jsx